/* globals debounce */
/* eslint-disable key-spacing, max-len, max-statements, wrap-iife, no-use-before-define */
(function($) {
  'use strict';

  var $inPageNav = $('.inpage-nav'),
    $inPageNavDropdown = $('.inpage-nav__dropdown'),
    $inPageNavSlider = $('.inpage-nav__content'),
    $currentAnchor = $('.inpage-nav__dropdown-current'),
    navResizeThrottle = false,
    navScrollThrottle = false,
    anchorScrollThrottle = false,
    mobileBreakpoint = 960,
    slickSettings = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: true,
      dots: false,
      focusOnSelect: true,
      prevArrow:
        '<div class="inpage-nav__back"><button class="btn inpage-nav__more-btn" aria-label="Back"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 13"><path fill="currentColor" fill-rule="evenodd" d="M1.514 0L0 1.518 4.971 6.5 0 11.48 1.514 13 8 6.5z"/></svg></button></div>',
      nextArrow:
        '<div class="inpage-nav__more"><button class="btn inpage-nav__more-btn" aria-label="More"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 13"><path fill="currentColor" fill-rule="evenodd" d="M1.514 0L0 1.518 4.971 6.5 0 11.48 1.514 13 8 6.5z"/></svg></button></div>',
      responsive: [
        {
          breakpoint: mobileBreakpoint,
          settings: 'unslick',
        },
      ],
    },
    $anchorTargets = $('h2[id]');

  if ($inPageNavSlider.length && $anchorTargets.length) {
    $inPageNavSlider.empty();
    $anchorTargets.each(function() {
      var $heading = $(this);
      var id = $heading.attr('id');
      var text = $heading.text();
      var link = $('<a/>', {
        text: text,
        href: '#' + id,
      });

      if (!$heading.data('inpageNavHide')) {
        link.appendTo($inPageNavSlider);
      }
    });
  } else {
    $inPageNav.remove();
    return;
  }

  // Set the accordion event for mobile
  $('.inpage-nav__dropdown > button').click(function() {
    var $accordionToggle = $(this).parent(),
      $accordionText = $accordionToggle.siblings('.inpage-nav__content');

    if ($accordionToggle.hasClass('active')) {
      $accordionToggle.removeClass('active');
      $accordionText.slideUp(300, function() {
        $accordionText.removeClass('active').removeAttr('style');
      });
    } else {
      var elemTotal =
          $accordionToggle.outerHeight() + $accordionToggle.offset().top,
        windowTotal = $(window).height() + $(window).scrollTop();

      $accordionToggle.addClass('active');
      $accordionText.css('max-height', windowTotal - elemTotal);

      $accordionText.slideDown({
        duration: 300,
        complete: function() {
          $accordionText.addClass('active');
        },
      });
    }

    return false;
  });

  // Initialise component if it exists
  if ($inPageNav.length > 0) {
    // Init Slick Slider
    $inPageNavSlider.slick(slickSettings);

    // Init slider options
    setSlidesToShow($inPageNavSlider);

    // Init afterChange slick event
    $inPageNavSlider.on(
      'afterChange',
      debounce(function() {
        setSlidesToShow($inPageNavSlider);
      }, 100)
    );

    // Init floating menu
    toggleFloatingMenu();

    // Init scrollTo
    if (window.location.href.split('#').length > 1) {
      $(window).on('load', function() {
        var destination =
          window.location.href.split('#')[1] !== ''
            ? window.location.href.split('#')[1]
            : false;
        if (destination) {
          scrollTo($('#' + destination));
        }
      });
    }

    // Init resize listeners
    $(window).on('resize', function() {
      toggleSlider();
      toggleFloatingMenu();
      updateCurrentAnchor();
    });

    // Init scroll listeners
    $(window).on('scroll', function() {
      toggleFloatingMenu();
      updateCurrentAnchor();
    });

    // Init blur listeners
    $inPageNavDropdown.on('blur', 'button', function(e) {
      var $focusTarget = $(e.relatedTarget);
      if (!$focusTarget.parent().hasClass('inpage-nav__content')) {
        // Close menu and active states
        $inPageNavSlider.slideUp(300, function() {
          $inPageNavSlider.removeClass('active').removeAttr('style');
          $inPageNavDropdown.removeClass('active');
        });
      }
    });

    // Init click listener for smooth scroll
    $inPageNav.on('click', 'a', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      if (href !== '#') {
        var $target = $(href);

        if ($inPageNavSlider.hasClass('active')) {
          // Close menu and active states
          $inPageNavSlider.slideUp(300, function() {
            $inPageNavSlider.removeClass('active').removeAttr('style');
            $inPageNavDropdown.removeClass('active');
          });
        }

        scrollTo($target);
      }
    });
  }

  function toggleSlider() {
    // Only fire function if it's not being throttled
    if (!navResizeThrottle) {
      var isDesktop = $(window).outerWidth() > mobileBreakpoint - 1,
        isSlick = $inPageNavSlider.hasClass('slick-slider');

      // Don't reslick if already slicked on desktop
      if (isDesktop && !isSlick) {
        $inPageNavSlider.slick(slickSettings);
      }

      // Set throttle to stop function running again
      navResizeThrottle = true;

      // Set throttle timeout to allow function to run after X milliseconds
      setTimeout(function() {
        navResizeThrottle = false;
      }, 100);
    }
  }

  function toggleFloatingMenu() {
    // Only fire function if it's not being throttled
    if (!navScrollThrottle) {
      updateFloatingMenu();

      // Set throttle to stop function running again
      navScrollThrottle = true;

      // Set throttle timeout to allow function to run after X milliseconds
      setTimeout(function() {
        navScrollThrottle = false;
      }, 100);
    }
  }

  function updateCurrentAnchor() {
    if (!anchorScrollThrottle) {
      // Default to first element
      var $anchor = $inPageNavSlider.children('a').first(),
        current = $anchor.text(),
        currentIndex = 0;

      $anchorTargets.each(function(index, elem) {
        var $accordionText = $(elem),
          elemOffset = $accordionText.offset().top,
          threshold = 80,
          navHeight = $inPageNav.outerHeight(),
          windowTop = $(window).scrollTop();

        // If we've scrolled within a certain distance of this header, add it as the next possible current anchor
        if (windowTop + navHeight >= elemOffset - threshold) {
          $anchor = $inPageNavSlider.find('a[href="#' + elem.id + '"]');
          current = $anchor.text();
          currentIndex = $inPageNavSlider.find('a').index($anchor);
        }
      });

      $currentAnchor.text(current);
      $inPageNavSlider.find('a').removeClass('current');
      $anchor.addClass('current');
      $inPageNavSlider.slick(
        'slickGoTo',
        currentIndex > 0 ? currentIndex - 1 : 0
      );

      // Set throttle to stop function running again
      anchorScrollThrottle = true;

      // Set throttle timeout to allow function to run after X milliseconds
      setTimeout(function() {
        anchorScrollThrottle = false;
      }, 50);
    }
  }

  /**
   * Toggles the in page nav component to a fixed position if it has been scrolled past
   * Otherwise it reverts to being positioned within its parent
   */
  function updateFloatingMenu() {
    var windowScroll = $(window).scrollTop(),
      menuBoundary =
        $inPageNav.parent().offset().top +
        $inPageNav.parent().outerHeight() -
        77;

    if (!$inPageNav.hasClass('sticky')) {
      if (windowScroll >= menuBoundary) {
        // Apply height to menu parent for when floating occurs
        $inPageNav.parent().css('height', $inPageNav.css('height'));
        $inPageNav.addClass('sticky');
      }
    } else {
      if (windowScroll < menuBoundary) {
        $inPageNav.css('top', '-100px');
        setTimeout(function() {
          $inPageNav.css('top', '');
          $inPageNav.removeClass('sticky');
          $inPageNav.parent().removeAttr('style');
        }, 100);
      }
      // If getting too close to the menu, remove sticky
      if (windowScroll < menuBoundary - 75) {
        $inPageNav.removeClass('sticky');
        $inPageNav.parent().removeAttr('style');
      }
    }
  }

  /**
   * Animate a smooth scroll to a particular element
   * @param {jQuery} $accordionText
   */
  function scrollTo($accordionText) {
    var scrollPosition =
      $accordionText.offset().top - $inPageNav.outerHeight() - 50;

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: scrollPosition,
        },
        500,
        'swing'
      );
  }

  /**
   * Return the number of slides shown currently on screen
   * @param {Slick Slider} $slider
   * @returns {Integer}
   */
  function getSlidesShown($slider) {
    var $slides = $($slider.find('.slick-slide'));

    if ($slides.length > 0) {
      var $list = $($slider.find('.slick-list')),
        $listOffset = Math.ceil($list.offset().left),
        $listWidth = Math.ceil($list.width()),
        $listTotal = $listWidth + $listOffset,
        results = 0;

      $slides.each(function(index, elem) {
        var $accordionText = $(elem),
          $accordionTextOffset = Math.ceil($accordionText.offset().left),
          $accordionTextWidth = Math.ceil($accordionText.width()),
          $accordionTextTotal = $accordionTextOffset + $accordionTextWidth;

        // If the element is fully within view, add to results
        if (
          $accordionTextOffset >= $listOffset &&
          $accordionTextTotal <= $listTotal
        ) {
          results = results + 1;
        }
      });

      return results;
    }

    return false;
  }

  /**
   * Take a slider and calculate which items are fully visible.
   * Set slidesToShow option to this number of items and refresh the UI.
   * @param {Slick Slider} slider
   * @returns
   */
  function setSlidesToShow($slider) {
    var results = getSlidesShown($slider);
    var slidesToShow = $slider.slick('slickGetOption', 'slidesToShow');

    if (results && results > 2 && results !== slidesToShow) {
      // Update slider to show number of sliders in view, making them tabbable
      $slider.slick('slickSetOption', 'slidesToShow', results, true);
      // Refresh slider
      // $slider.slick('slickGoTo', $slider.slick('slickCurrentSlide'));

      return true;
    }

    return false;
  }
})(jQuery);
